import { NdSkladPreceneni } from './ndSkladPreceneni';
import { NdSklad } from './ndSklad';
import { NdPrijemka } from './ndPrijemka';
import { NdPohyb } from './ndPohyb';
import { NdObjednavka } from './ndObjednavka';
import { PROrders } from './PROrders';
import { NdCenik } from './ndCenik';
import { PneuSklad } from './pneuSklad';
import { Inventura } from './inventura';
import { PRReturn } from './PRReturn';
import { Edl } from './edl';
import { PRInvoice } from './PRInvoice';
import { CustomerPendingEnquiries } from './CustomerPendingEnquiries';
import { PartsInventoryAdjustment } from './partsInventoryAdjustments';
import { BulkInventoryApproval } from './BulkInventoryApproval';
import { BulkInventoryAdjustments } from './BulkInventoryAdjustments';

export const menu = {
	name: 'SkladyNd',
	orderAlphabetically: false,
	list: [
		{ name: 'pAgendaSkladuND', route: NdSklad.name },
		{ name: 'pCenikND', route: NdCenik.name },
		{ name: 'EdlNd', route: Edl.name },
		{ name: 'ND_Prijem', route: NdPrijemka.name },
		{ name: 'pObjednavky', route: NdObjednavka.name },
		{ name: 'PROrders', route: PROrders.name },
		{ name: 'PRINVOICE', route: PRInvoice.name },
		{ name: 'ND_Pohyb', route: NdPohyb.name },
		{ name: 'ND_Preceneni', route: NdSkladPreceneni.name },
		{ name: 'Inventura', route: Inventura.name },
		{ name: 'UdrzbaSkladPneu', route: PneuSklad.name },
		{ name: 'PRReturn', route: PRReturn.name },
		{ name: 'CustomerPendingEnquiries', route: CustomerPendingEnquiries.name },
		{ name: 'PARTS_INVEN_ADJUSTMENT', route: PartsInventoryAdjustment.name },
		{ name: 'BulkInventoryApproval', route: BulkInventoryApproval.name },
		{ name: 'BulkInventoryAdjustments', route: BulkInventoryAdjustments.name },
		
	],
};
